/**
 * Created by DSadler on 02/05/2017.
 */

/*let image = {
  imageId: "",
  imageName: "",
  imageUrl: "",
  imageCategory: "",
  imageAdded: "",
  builtIn: "",
};*/

export const CREATE_IMAGE = "CREATE_IMAGE";
export const UPDATE_IMAGE = "UPDATE_IMAGE";
export const DELETE_IMAGE = "DELETE_IMAGE";
export const SET_IMAGES = "SET_IMAGES";

export function createImage(imageId, imageName, imageCategory, imageUrl) {
  return {
    type: CREATE_IMAGE,
    imageId,
    imageName,
    imageCategory,
    imageUrl,
  }
}

export function updateImage(imageId, imageItem) {
  return {
    type: UPDATE_IMAGE,
    imageId,
    imageItem,
  }
}

export function deleteImage(imageId) {
  return {
    type: DELETE_IMAGE,
    imageId,
  }
}

export function setImages(images) {
  return {
    type: SET_IMAGES,
    images,
  }
}


// WEBPACK FOOTER //
// ./src/App/state/images/actions.js